import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=a31b0c10"
import script from "./ProductsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsFilter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports